export default function TerminalWindow({
  title = "MGFC.SYS",
  status,
  accent = "cyan",
  children,
  className = "",
  bodyClassName = "",
}) {
  const accentColor =
    accent === "magenta"
      ? "#FF00FF"
      : accent === "lime"
        ? "#9FFF00"
        : accent === "orange"
          ? "#FF9900"
          : "#00FFFF";

  const glow =
    accent === "magenta"
      ? "shadow-[0_0_30px_rgba(255,0,255,0.18)]"
      : accent === "lime"
        ? "shadow-[0_0_30px_rgba(159,255,0,0.18)]"
        : accent === "orange"
          ? "shadow-[0_0_30px_rgba(255,153,0,0.18)]"
          : "shadow-[0_0_30px_rgba(0,255,255,0.18)]";

  return (
    <div
      className={`relative bg-mgfc-bg/80 backdrop-blur-md ${glow} ${className}`}
      style={{ border: `2px solid ${accentColor}` }}
    >
      <div
        className="flex items-center gap-3 border-b px-3 py-2 sm:px-4"
        style={{
          borderColor: accentColor,
          background: `${accentColor}1A`,
        }}
      >
        <div className="flex gap-1.5">
          <span className="block h-2.5 w-2.5 rounded-full bg-mgfc-magenta" />
          <span className="block h-2.5 w-2.5 rounded-full bg-mgfc-cyan" />
          <span className="block h-2.5 w-2.5 rounded-full bg-mgfc-orange" />
        </div>
        <span
          className="flex-1 truncate font-mono text-[11px] uppercase tracking-[0.25em]"
          style={{ color: accentColor }}
        >
          {title}
        </span>
        {status && (
          <span className="hidden font-mono text-[10px] uppercase tracking-[0.3em] text-mgfc-fg/50 sm:inline">
            {status}
          </span>
        )}
      </div>
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}
